import { render, staticRenderFns } from "./RefusedLoans.vue?vue&type=template&id=5812944e"
import script from "./RefusedLoans.vue?vue&type=script&lang=js"
export * from "./RefusedLoans.vue?vue&type=script&lang=js"
import style0 from "./RefusedLoans.vue?vue&type=style&index=0&id=5812944e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports